import type { ChannelMiniEntity } from '@/features/channel/domain/entities/ChannelMiniEntity'
import type { DriverEntity } from '@/features/driver/domain/entities/DriverEntity'

export class CreateUpdateDriverTeamEntity {
  name?: string
  drivers?: Array<DriverEntity> | null
  channels?: Array<ChannelMiniEntity> | null
}
